import { Text, Box } from '@chakra-ui/react';
import { format, parseISO } from 'date-fns';

const ServiceItem: React.FC<{ title: string; remaining: number; activated: string; expires: string }> = ({
  title,
  remaining,
  activated,
  expires,
}) => {
  return (
    <Box w="full" className="accountService" sx={{ borderBottom: '1px solid black', paddingBottom: 3 }}>
      <Text fontSize="l" mt={3} fontWeight="semibold">
        {title}
      </Text>
      <Box justifyContent="space-between">
        <Text fontSize="sm">Sessions restantes : {remaining}</Text>
        <Text fontSize="sm">
          Activé : {format(parseISO(activated), 'dd/MM/yyyy')} | Expire : {format(parseISO(expires), 'dd/MM/yyyy')}
        </Text>
      </Box>
    </Box>
  );
};

export default ServiceItem;
